import { PERMISSION_MODULES, PERMISSION_MODULES_DEFAULT } from "../types";

const initialState = {
  response: null,
  isAdmin: false,
};

export default function permissionReducer(state = initialState, action) {
  switch (action.type) {
    case PERMISSION_MODULES_DEFAULT:
      return {
        ...state,
        isAdmin: action.payload.isAdmin,
        response: action.payload.data,
      };
    case PERMISSION_MODULES:
      return {
        ...state,
        isAdmin: action.payload.isAdmin,
        detail: false,
        response: action.payload.data,
      };
    default:
      return state;
  }
}
